var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.128,
    height: 16,
    viewBox: "0 0 13.128 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seat",
    transform: "translate(-37.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2781",
    "data-name": "Group 2781",
    transform: "translate(37.333 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2780",
    "data-name": "Group 2780",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40775",
    "data-name": "Path 40775",
    d: "M104.136,2.8a1.642,1.642,0,1,0-2.322,0A1.644,1.644,0,0,0,104.136,2.8Z",
    transform: "translate(-98.872 0)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40776",
    "data-name": "Path 40776",
    d: "M107.843,113.127h-2.818v-3.02a7.841,7.841,0,0,0,4.513,1.772v-1.772a5.542,5.542,0,0,1-3.832-1.674l-1.149-1.272a1.849,1.849,0,0,0-.562-.414,1.8,1.8,0,0,0-.792-.189h-.02a1.853,1.853,0,0,0-1.85,1.85v4.718a2.463,2.463,0,0,0,2.462,2.462h4.156l2.872,2.872L112,117.283Z",
    transform: "translate(-98.871 -102.461)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40777",
    "data-name": "Path 40777",
    d: "M38.974,114.052v-7.385H37.333v7.385a4.1,4.1,0,0,0,4.1,4.1h4.923v-1.641H41.436A2.463,2.463,0,0,1,38.974,114.052Z",
    transform: "translate(-37.333 -102.564)",
    fill: "#6f6f6f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/seat.650c9e81.svg";
export { ForwardRef as ReactComponent };